import { getDoc, doc } from 'firebase/firestore';
import { db } from '../firebase';
import moment from 'moment';

export const checkExistingRecords = async (userId, newStart, newEnd) => {
  let current = moment(newStart);
  const end = moment(newEnd);

  // Agrupar días por mes para minimizar consultas a Firestore
  const daysByMonth = {};

  while (current.isSameOrBefore(end)) {
    const monthKey = current.format('MMMM-YYYY');
    const dateKey = current.format('DD-MM-YYYY');

    if (!daysByMonth[monthKey]) {
      daysByMonth[monthKey] = [];
    }
    daysByMonth[monthKey].push(dateKey);

    current.add(1, 'days');
  }

  const matchingDays = [];

  // Consultar cada mes una sola vez
  for (const monthKey of Object.keys(daysByMonth)) {
    const recordsDoc = await getDoc(doc(db, 'users', userId, 'registros', monthKey));

    if (recordsDoc.exists() && recordsDoc.data()) {
      const records = recordsDoc.data();
      for (const dateKey of daysByMonth[monthKey]) {
        if (records[dateKey]) {
          matchingDays.push(dateKey);
        }
      }
    }
  }

  return matchingDays;
};
